import cancelProcess from './cancelProcess'
import getFilesByClient from './getFilesByClient'
import getUsers from './getUsers'
import uploadFile from './uploadFile'

export const cancelProcessPromise = cancelProcess
export const getFilesByClientPromise = getFilesByClient
export const getUsersPromise = getUsers
export const uploadFilePromise = uploadFile
